/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CostMultiplierVehicleTypeMultipliersInner model module.
 * @module model/CostMultiplierVehicleTypeMultipliersInner
 * @version 0.0.2
 */
class CostMultiplierVehicleTypeMultipliersInner {
    /**
     * Constructs a new <code>CostMultiplierVehicleTypeMultipliersInner</code>.
     * @alias module:model/CostMultiplierVehicleTypeMultipliersInner
     */
    constructor() { 
        
        CostMultiplierVehicleTypeMultipliersInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
        obj['multiplier'] = 1.0;
    }

    /**
     * Constructs a <code>CostMultiplierVehicleTypeMultipliersInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostMultiplierVehicleTypeMultipliersInner} obj Optional instance to populate.
     * @return {module:model/CostMultiplierVehicleTypeMultipliersInner} The populated <code>CostMultiplierVehicleTypeMultipliersInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostMultiplierVehicleTypeMultipliersInner();

            if (data.hasOwnProperty('vehicleTypeId')) {
                obj['vehicleTypeId'] = ApiClient.convertToType(data['vehicleTypeId'], 'String');
            }
            if (data.hasOwnProperty('multiplier')) {
                obj['multiplier'] = ApiClient.convertToType(data['multiplier'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostMultiplierVehicleTypeMultipliersInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostMultiplierVehicleTypeMultipliersInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['vehicleTypeId'] && !(typeof data['vehicleTypeId'] === 'string' || data['vehicleTypeId'] instanceof String)) {
            throw new Error("Expected the field `vehicleTypeId` to be a primitive type in the JSON string but got " + data['vehicleTypeId']);
        }

        return true;
    }


}



/**
 * The vehicleTypeId for which this cost multiplier applies. If not provided, then the cost multiplier will apply to all vehicle types.
 * @member {String} vehicleTypeId
 */
CostMultiplierVehicleTypeMultipliersInner.prototype['vehicleTypeId'] = undefined;

/**
 * The multiplier to apply to the base cost metric (duration or distance) for this vehicle type.
 * @member {Number} multiplier
 * @default 1.0
 */
CostMultiplierVehicleTypeMultipliersInner.prototype['multiplier'] = 1.0;






export default CostMultiplierVehicleTypeMultipliersInner;

